import React from 'react';
import { Route, IndexRoute } from 'react-router';
import TranslationProvider from 'client/components/translationProvider';
import { bindPageViewTracking } from 'utils/tracking';
import App from './app';
import CovidPageContainer from './covidPageContainer';
import FinanceGuidePageContainer from './financeGuidePageContainer';
import FindWorkPageContainer from './findWorkPageContainer';
import HealthGuidePageContainer from './healthGuidePageContainer';
import TaxGuidePageContainer from './taxGuidePageContainer';

export default (
  <Route path="/" component={App}>
    <Route component={TranslationProvider} keys={['app', 'common']}>
      <IndexRoute component={CovidPageContainer} onEnter={bindPageViewTracking()} />
      <Route
        path="/finance-guide"
        component={FinanceGuidePageContainer}
        onEnter={bindPageViewTracking()} />
      <Route
        path="/health-guide"
        component={HealthGuidePageContainer}
        onEnter={bindPageViewTracking()} />
      <Route path="/tax-guide" component={TaxGuidePageContainer} onEnter={bindPageViewTracking()} />
      <Route path="/find-work" component={FindWorkPageContainer} onEnter={bindPageViewTracking()} />
    </Route>
  </Route>
);
